import React from 'react';
import { TextLocationEnum } from '../_types';
import { uid } from '../_utils';
var ToggleSwitch = function (props) {
    var _a = props.textLocation, textLocation = _a === void 0 ? TextLocationEnum.Outside : _a, _b = props.id, id = _b === void 0 ? uid('toggle-switch') : _b, _c = props.small, small = _c === void 0 ? false : _c, _d = props.green, green = _d === void 0 ? false : _d, _e = props.checked, checked = _e === void 0 ? false : _e, _f = props.disabled, disabled = _f === void 0 ? false : _f, _g = props.required, required = _g === void 0 ? false : _g, onChange = props.onChange, children = props.children, className = props.className;
    var showToggleText = function () { return textLocation !== TextLocationEnum.Hidden; };
    var getCustomClasses = function () {
        var textLocation = getTextLocation();
        var classes = '';
        if (textLocation === TextLocationEnum.Outside) {
            classes += ' custom-switch-text-outside';
        }
        else if (textLocation === TextLocationEnum.Inside) {
            classes += ' custom-switch-text-inside';
        }
        if (!small || (small && textLocation === TextLocationEnum.Inside))
            classes += ' custom-switch-lg';
        if (green)
            classes += ' custom-switch-green';
        if (className)
            classes += " " + className;
        return classes;
    };
    var getTextLocation = function () {
        switch (textLocation) {
            case TextLocationEnum.Inside:
            case TextLocationEnum.Outside:
                return textLocation;
            default:
                return TextLocationEnum.Hidden;
        }
    };
    return (React.createElement("div", { className: "custom-control custom-switch" + getCustomClasses() },
        React.createElement("input", { id: id, type: "checkbox", autoComplete: "off", className: "custom-control-input", checked: checked, disabled: disabled, required: required, onChange: function (nativeEvent) { return onChange && onChange(nativeEvent); } }),
        React.createElement("label", { className: "custom-control-label", htmlFor: id },
            showToggleText() ? (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "custom-switch-text custom-switch-text-on" }, "On"),
                React.createElement("span", { className: "custom-switch-text custom-switch-text-off" }, "Off"))) : null,
            children)));
};
export default ToggleSwitch;
